/**
 * Format CHNX amount for display (2 decimal places)
 * Use this for all UI display purposes
 * 
 * @param amount CHNX token amount (string or number)
 * @returns Formatted string with 2 decimal places (e.g., "10.12")
 */
export function formatCHNX(amount: string | number): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '0.00';
  return num.toFixed(2);
}
